import cc from 'classcat';
import React from 'react';

import styles from './CallsToAction.scss';
import { CTA } from './CTA';

export const CallsToAction = React.forwardRef(
  ({ items, theme, isDarkBackground, className }, ref) => {
    return !items?.length ? null : (
      <div className={cc([styles.ctasContainer, className])} ref={ref}>
        {items.map((cta, i) => (
          <CTA
            className={cc([
              i > 0 ? styles.skySecondaryButton : styles.skyPrimaryButton,
            ])}
            key={i}
            cta={cta}
            {...{ theme, isDarkBackground }}
          />
        ))}
      </div>
    );
  }
);
